export enum WebHookQueryType {
  GAME_CENTER_SIGN_UP ='?webhookEvent=GAME_CENTER_SIGN_UP',
  GAME_CENTER_ADDITIONAL_FORM_SUBMISSION ='?webhookEvent=GAME_CENTER_ADDITIONAL_FORM_SUBMISSION',
  DEFAULT = ''
}